import { withFormik } from 'formik';
import { connect } from 'react-redux';
import { resetPassword } from '../../../slices/authSlice';
import { ResetPasswordForm } from './ResetPasswordForm';
import * as Yup from 'yup';

//constants
import {
  PASSWORD_REQUIRED,
  PASSWORD_SHORT_ERROR,
} from '../../../constants/messages/formMessages';

const EnhancedResetPasswordForm = withFormik({
  mapPropsToValues: () => ({
    password: '',
  }),
  validationSchema: Yup.object().shape({
    password: Yup.string()
      .required(PASSWORD_REQUIRED)
      .min(6, PASSWORD_SHORT_ERROR),
  }),
  handleSubmit: (values, { props, setSubmitting }) => {
    const { resetPassword, history, token } = props;
    resetPassword(token, values.password, history);
    setSubmitting(false);
  },
  displayName: 'ResetPasswordForm',
})(ResetPasswordForm);

export default connect(null, { resetPassword })(EnhancedResetPasswordForm);
